{
  "fields": {
    "number": {
      "resultValue": "Итоговое значение"
    }
  }
}